// The versions page used to poll every 5s for as long as it was open, and
// every poll was logged as a page view. Versions are also created OUTSIDE
// this page -- the Unity Editor uploads them -- so we can never drop to 0
// and rely on the admin to notice: a new upload would never appear until a
// manual reload. Instead we poll fast while something is actively changing
// and slow the rest of the time, so an idle admin still discovers an
// Editor-initiated upload without refreshing. Both intervals are safe to run
// indefinitely because every poll (`table-ag-client.js`'s `runInBackground`
// wrapper) is marked `edxr-bg=1` and writes no log rows (audit-trail spec
// §4.5).
//
// Status vocabulary is `model.AssetVersionStatus` in rapid-api-core
// (database/model/asset-version.go): pending, complete, canceled, error.
// "Only pending versions should ever transition" -- so pending is the only
// non-finished status; complete, canceled, and error are all terminal.
const FINISHED = ['complete', 'canceled', 'error']

export const POLL_ACTIVE_MS = 30000
export const POLL_IDLE_MS = 120000

export const versionPollInterval = versions =>
  (versions || []).some(v => !FINISHED.includes(v.status)) ? POLL_ACTIVE_MS : POLL_IDLE_MS
